import React from "react";
import YellowLinkIcon from "../../../assets/icons/front-pages/link-yellow.svg";
import YellowStoreIcon from "../../../assets/icons/front-pages/store-yellow.svg";
import YellowMessageIcon from "../../../assets/icons/front-pages/message-notif.svg";
import YellowChartIcon from "../../../assets/icons/front-pages/chart-yellow.svg";
import { FrontPagesFeatures } from "../commons";

const StoreLinkFeatures = () => {
  return (
    <FrontPagesFeatures
      headerTextSeries={[
        ["What", "do", "you", "get"],
        ["with", "store", "links"],
      ]}
      cta={{
        title: (
          <>
            Ready to take <br /> orders easily?
          </>
        ),
        text: "Start using links",
      }}
      features={features}
      image={{
        src: "https://res.cloudinary.com/catlog/image/upload/v1670574046/front-pages/woman-with-headphones-large.webp",
        alt: "Woman with headphones",
      }}
    />
  );
};

const features = [
  {
    icon: YellowLinkIcon,
    description: "One link you can share everywhere and anywhere",
  },
  {
    icon: YellowStoreIcon,
    description: "A beautiful storefront to showcase your products",
  },
  {
    icon: YellowMessageIcon,
    description: "Get order & delivery details as a message on whatsapp",
  },
  {
    icon: YellowChartIcon,
    description: "A dashboard to track how well your store is performing",
  },
];

export default StoreLinkFeatures;
